import React from "react";
import './SepLine.css'

function SepLine(){

    return(
        <div className="break-line"></div>
    )
}

export default SepLine